<script>
import ContentBlockView from '@shared/mixins/ContentBlockView';
import VueSimpleEmbed from '@shared/components/VueSimpleEmbed.vue';
import VideoCtas from '@shared/components/VideoCtas.vue';

export default {
  mixins: [ContentBlockView],
  components: {
    VueSimpleEmbed,
    VideoCtas,
  },
  data() {
    return {
      hasPlayerMounted: false,
    };
  },
  computed: {
    dynamicData() {
      const path = this.data.path.startsWith('http')
        ? this.data.path
        : `${this.$env.apiResourcesURL}/${this.data.path}`;

      return { path };
    },
    hasTimecode() {
      return (
        this.data
        && this.data.timecodes
        && this.data.timecodes.length
      );
    },
    hasCtas() {
      return (
        this.data
        && this.data.ctas
        && this.data.ctas.length
      );
    },
    videoChapteringTitle() {
      return this.$t('video_chaptering_title');
    },
  },
  mounted() {
    this.hasPlayerMounted = !!this.$refs.player;
  },
  updated() {
    this.hasPlayerMounted = !!this.$refs.player;
  },
  methods: {
    goToTimecode(timecode) {
      const { player } = this.$refs.player;
      const timeSplitted = timecode.time.split(':');
      const timeInSeconds = Math.min(
        player.duration - 1,
        parseInt(timeSplitted[0] * 60, 10) + parseInt(timeSplitted[1], 10),
      );

      if (!Number.isNaN(timeInSeconds)) {
        player.play();
        player.currentTime = timeInSeconds;
      }
    },
  },
  i18n: {
    messages: {
      en: {
        video_chaptering_title: 'Video chaptering',
      },
      fr: {
        video_chaptering_title: 'Chapitrage de la vidéo',
      },
    },
  },
};
</script>

<template>
  <div>
    <figure class="image has-text-centered overflow-visible">
      <template v-if="data.srcType != 'embed'">
        <vue-plyr ref="player">
          <video class="w-auto mw-full mx-auto" :src="`${dynamicData.path}#t=0.001`" />
        </vue-plyr>
        <VideoCtas
          v-if="hasCtas"
          :ctas="data.ctas"
          :player="hasPlayerMounted && $refs.player ? $refs.player.player : null"
        />
        <figcaption v-if="data.caption" class="pt-3 has-text-centered is-size-8">
          {{ data.caption }}
        </figcaption>
        <div v-if="hasTimecode" class="box content has-text-justified mt-3">
          <h3 class="is-size-5-touch">
            {{ videoChapteringTitle }}
          </h3>
          <ul>
            <li v-for="(timecode, k) in data.timecodes" :key="k">
              {{ timecode.title }} :
              <a href="#" @click.prevent="goToTimecode(timecode)">
                {{ timecode.time }}
              </a>
            </li>
          </ul>
        </div>
      </template>
      <VueSimpleEmbed v-else
        class="has-text-centered"
        :attrs="{
          class: 'mw-full mx-auto',
          width: '728',
          height: '546'
        }"
        parser="plyr"
        :extra-data="data"
        :url="`${data.path}#t=0.001`"
      >
        <template v-if="data.caption" #caption>
          <figcaption class="pt-3 has-text-centered is-size-8">
            {{ data.caption }}
          </figcaption>
        </template>
      </VueSimpleEmbed>
    </figure>
  </div>
</template>
